import { atom } from 'jotai';
import { createContext, useContext } from 'react';
import invariant from 'tiny-invariant';
import { getStrategy } from '../strategy';
import type { PlanStrategy } from '../strategy/type';
import { __planAtom } from './plan';

// Only the loading boundary consumes this asynchronous resource. Domain atoms
// are bound to the concrete strategy provided after it resolves.
export const strategyResourceAtom = atom((get) => {
  const plan = get(__planAtom);
  // Atom evaluations are cached per store; do not share this promise across stores.
  return plan ? getStrategy(plan.plan_strategy) : new Promise<never>(() => {});
});

export const PlanStrategyContext = createContext<PlanStrategy | undefined>(undefined);

export function usePlanStrategy() {
  const strategy = useContext(PlanStrategyContext);
  invariant(strategy, 'Plan strategy must be read inside the plan loading boundary');
  return strategy;
}
